import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Cancelled from "../common/Cancelled";
import { getTargetGroupDetails } from "../utils";

const TargetGroupCancelled = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getTargetGroupDetails(log);
  return <Cancelled name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default TargetGroupCancelled;
